export const getCurrency = (_, props) => props.currency
